import React, { useContext, useRef, useState } from "react";
import Title from "../components/Title";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { FaTrash } from "react-icons/fa";
import { getToken } from "../slice/tokenSlice";
import { AppContext } from "../context/AppContext";

const ParaLegal = () => {
  const { url, user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { notifySuccess } = useContext(AppContext);
  const callInputTemplate = {
    Creditor_Agent_Mobile_Number: "",
    Creditor_Agent_Landline_Number: "",
    How_many_calls_have_you_received: "",
    Do_you_have_a_screenshot_of_the_received_calls: "",
  };
  const [callInputs, setCallInputs] = useState([callInputTemplate]);
  const [callInputErrors, setCallInputErrors] = useState([]);
  const addMoreCallInputs = () => {
    setCallInputs([...callInputs, callInputTemplate]);
  };
  const deleteCallInput = (index) => {
    setCallInputs((prevInputs) => prevInputs.filter((_, i) => i !== index));
  };
  const handleCallInputChange = (index, field, value) => {
    setCallInputs((prevInputs) =>
      prevInputs.map((input, i) =>
        i === index ? { ...input, [field]: value } : input,
      ),
    );
    setCallInputErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      if (newErrors[index]) {
        newErrors[index] = { ...newErrors[index], [field]: undefined };
      }
      return newErrors;
    });
  };
  const validateCallInputs = async () => {
    const errors = [];
    callInputs.forEach((input) => {
      const rowErrors = {};

      const num1 = input.Creditor_Agent_Mobile_Number.trim();
      const num2 = input.Creditor_Agent_Landline_Number.trim();

      // At least one number required
      if (!num1 && !num2) {
        rowErrors.Creditor_Agent_Mobile_Number =
          "Enter at least one agent number.";
        rowErrors.Creditor_Agent_Landline_Number =
          "Enter at least one agent number.";
      }

      // Validate first number if entered
      if (num1 && !/^[1-9]\d{9}$/.test(num1)) {
        rowErrors.Creditor_Agent_Mobile_Number =
          "Must be a valid 10-digit number and cannot start with 0.";
      }

      // Validate second number if entered
      if (num2 && !/^[1-9]\d{9}$/.test(num2)) {
        rowErrors.Creditor_Agent_Landline_Number =
          "Must be a valid 10-digit number and cannot start with 0.";
      }

      if (!input.How_many_calls_have_you_received.trim()) {
        rowErrors.How_many_calls_have_you_received =
          "Select how many calls you received.";
      }

      if (!input.Do_you_have_a_screenshot_of_the_received_calls.trim()) {
        rowErrors.Do_you_have_a_screenshot_of_the_received_calls =
          "Select Yes or No.";
      }

      errors.push(rowErrors);
    });
    const hasErrors = errors.some((err) => Object.keys(err).length > 0);
    if (hasErrors) {
      setCallInputErrors(errors);
      return false;
    } else {
      try {
        const token = await dispatch(getToken());
        const data = [
          {
            Lead_Name: user.id,
            Title: "Creditor & Agent Calls",
            Client_Comments: "Report harassing phone calls",
            Creditor_And_Agent_Calls: callInputs,
            Department: "Paralegal",
          },
        ];

        const res = await axios.post(
          `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SML_Portal`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Zoho-oauthtoken ${token.payload}`,
            },
          },
        );

        if (res.status === 201) {
          setCallInputErrors([]);
          setCallInputs([callInputTemplate]);
          notifySuccess("Data saved");
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  //
  const [visitInputs, setVisitInputs] = useState({
    agentVisit: "",
    still: "",
    callNow: "",
    agentNumber: "",
    agentName: "",
    notification: "",
    message: "",
  });
  const [visitInputsError, setVisitInputsErrors] = useState({});
  const handleVisitInputs = (e) => {
    const { name, value } = e.target;
    setVisitInputs({
      ...visitInputs,
      [name]: value,
    });
    setVisitInputsErrors({
      ...visitInputsError,
      [name]: "",
    });
  };
  const submitVisitInputs = async () => {
    const {
      agentVisit,
      still,
      callNow,
      agentNumber,
      agentName,
      notification,
      message,
    } = visitInputs;
    const newErrors = {};
    if (!["yes", "no"].includes(agentVisit.toLowerCase().trim())) {
      newErrors.agentVisit = "Agent visit must be 'yes' or 'no'";
    }
    if (agentVisit.toLowerCase().trim() === "yes") {
      if (!still.toLowerCase().trim()) {
        newErrors.still = "Still image is required when agent visit is 'yes'.";
      }
    }
    if (!callNow.toLowerCase().trim())
      newErrors.callNow = "Call Now is required.";
    if (!agentNumber.toLowerCase().trim()) {
      newErrors.agentNumber = "Agent number is required.";
    } else if (!/^\d{10}$/.test(agentNumber.toLowerCase().trim())) {
      newErrors.agentNumber = "Agent number must be a 10-digit number.";
    }
    if (!agentName.toLowerCase().trim())
      newErrors.agentName = "Agent name is required.";
    if (!notification.toLowerCase().trim())
      newErrors.notification = "Notification is required.";
    if (notification.toLowerCase() === "yes") {
      if (!message.toLowerCase().trim())
        newErrors.message = "Message is required.";
    }
    if (Object.keys(newErrors).length > 0) {
      setVisitInputsErrors(newErrors);
      console.log(newErrors);
      return;
    }
    setVisitInputsErrors({});
    try {
      const token = await dispatch(getToken());
      const data = [
        {
          Lead_Name: user.id,
          Title: "Creditor & Collection Agent Visits",
          Have_you_had_a_creditor_or_Agent_visit: agentVisit,
          Name_of_the_creditor: agentName,
          Provide_the_collection_Creditor_Agent_Mobile_Number: agentNumber,
          Do_you_need_us_to_call_you_as_soon_as_possible: callNow,
          Have_you_received_a_notification_of_a_visit: notification,
          Is_the_Agent_still_at_your_address: still,
          You_can_copy_and_paste_the_message: message,
          Client_Comments: "Report creditor visits to my address",
          Department: "Paralegal",
        },
      ];
      const res = await axios.post(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SML_Portal`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        },
      );
      if (res.status === 201) {
        setVisitInputs({
          agentVisit: "",
          still: "",
          callNow: "",
          agentNumber: "",
          agentName: "",
          notification: "",
          message: "",
        });
        notifySuccess("Data saved");
      }
    } catch (error) {
      console.log(error);
    }
  };
  //
  const submitIssue = async (option) => {
    try {
      const token = await dispatch(getToken());
      const data = [
        {
          Lead_Name: user.id,
          Title: "Call Forwarding",
          My_call_forwarding_is_not_working: option,
          Client_Comments: "Technical issue with call forwarding",
          Department: "Paralegal",
        },
      ];
      const res = await axios.post(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SML_Portal`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token.payload}`,
          },
        },
      );
      if (res.status === 201) {
        notifySuccess("Data saved");
      }
    } catch (error) {
      console.log(error);
    }
  };
  //
  const [otherIssue, setOtherIssue] = useState("");
  const [otherIssueError, setOtherIssueError] = useState("");
  const handleOtherIssue = (e) => {
    setOtherIssue(e.target.value);
    setOtherIssueError("");
  };
  const [file, setFile] = useState(null);
  const handleFile = (e) => {
    setFile(e.target.files[0]);
    setFileError("");
  };
  const [fileError, setFileError] = useState("");
  const fileInput = useRef(null);
  const submitOtherIssue = async () => {
    const token = await dispatch(getToken());
    if (otherIssue === "") {
      setOtherIssueError("Please enter the issue you are facing");
    } else {
      const allowedTypes = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "video/mp4",
        "video/webm",
        "video/ogg",
      ];
      if (file && !allowedTypes.includes(file.type)) {
        setFileError(
          "Only PDF, PNG, JPEG, or video files (MP4, WebM, OGG) are allowed.",
        );
      } else {
        const data = [
          {
            Title: "Other creditor issue",
            Client_Comments: otherIssue,
            Lead_Name: user.id,
            Added_By: user.Full_Name,
            Department: "Paralegal",
          },
        ];
        const res = await axios.post(
          `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SML_Portal`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Zoho-oauthtoken ${token.payload}`,
            },
          },
        );
        if (res.status === 201) {
          notifySuccess("Data saved");
          setOtherIssue("");
          setFileError("");
          if (file) {
            const formdata = new FormData();
            formdata.append("file", file);
            const fileRes = await axios.post(
              `${url}/proxy?url=https://www.zohoapis.in/crm/v5/SML_Portal/${res.data.data[0].details.id}/Attachments`,
              formdata,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Zoho-oauthtoken ${token.payload}`,
                },
              },
            );
            if (fileRes.status === 200) {
              setFile(null);
            }
          }
        }
      }
    }
  };
  return (
    <>
      <Title title={"Para Legal"} />
      <div className="my-4">
        <p className="fw-bold">Creditor & Agent Calls</p>
        <ul className="mb-2">
          <li>Report harassing phone calls</li>
          <li>Track call frequency and patterns</li>
          <li>Submit call evidence</li>
        </ul>

        {callInputs.map((item, index) => {
          return (
            <div className={`${index === 0 ? "mt-2" : "mt-5"}`} key={index}>
              <div className="d-flex align-items-center justify-content-between">
                <p className="fw-bold">Creditor {index + 1}</p>
                {callInputs.length > 1 && (
                  <button
                    className="red-button"
                    onClick={() => deleteCallInput(index)}
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
              <div className="mb-2">
                <p>Creditor agent mobile number</p>
                <div className="attached-input">
                  <input
                    type="text"
                    className="input code"
                    value="+91"
                    disabled
                  />
                  <input
                    type="number"
                    className="input digit"
                    value={item.Creditor_Agent_Mobile_Number}
                    onChange={(e) =>
                      handleCallInputChange(
                        index,
                        "Creditor_Agent_Mobile_Number",
                        e.target.value,
                      )
                    }
                  />
                </div>
                {callInputErrors[index]?.Creditor_Agent_Mobile_Number && (
                  <p className="text-danger">
                    {callInputErrors[index].Creditor_Agent_Mobile_Number}
                  </p>
                )}
              </div>
              <div className="mb-2">
                <p>Creditor agent landline number</p>
                <div className="attached-input">
                  <input
                    type="number"
                    className="input px-4"
                    placeholder="Another number"
                    value={item.Creditor_Agent_Landline_Number}
                    onChange={(e) =>
                      handleCallInputChange(
                        index,
                        "Creditor_Agent_Landline_Number",
                        e.target.value,
                      )
                    }
                  />
                </div>
                {callInputErrors[index]?.Creditor_Agent_Landline_Number && (
                  <p className="text-danger">
                    {callInputErrors[index].Creditor_Agent_Landline_Number}
                  </p>
                )}
              </div>
              <div className="mb-2">
                <p>How many calls have your recieved from this number</p>
                <select
                  className="input"
                  value={item.How_many_calls_have_you_received}
                  onChange={(e) =>
                    handleCallInputChange(
                      index,
                      "How_many_calls_have_you_received",
                      e.target.value,
                    )
                  }
                >
                  <option value="">Please select</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5+">5+</option>
                </select>
                {callInputErrors[index]?.How_many_calls_have_you_received && (
                  <p className="text-danger">
                    {callInputErrors[index].How_many_calls_have_you_received}
                  </p>
                )}
              </div>
              <div className="mb-2 hr pb-2">
                <p>Do you have screenshot of the recieved calls?</p>
                <select
                  className="input"
                  value={item.Do_you_have_a_screenshot_of_the_received_calls}
                  onChange={(e) =>
                    handleCallInputChange(
                      index,
                      "Do_you_have_a_screenshot_of_the_received_calls",
                      e.target.value,
                    )
                  }
                >
                  <option value="">Please select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                {callInputErrors[index]
                  ?.Do_you_have_a_screenshot_of_the_received_calls && (
                  <p className="text-danger">
                    {
                      callInputErrors[index]
                        .Do_you_have_a_screenshot_of_the_received_calls
                    }
                  </p>
                )}
              </div>
            </div>
          );
        })}
        <div className="d-flex align-items-center justify-content-end gap-2 mt-2">
          <button className="button" onClick={addMoreCallInputs}>
            Add more
          </button>
          <button className="button" onClick={validateCallInputs}>
            Submit
          </button>
        </div>
      </div>
      <hr />
      <div className="my-4">
        <p className="fw-bold">Creditor & Collection Agent Visits</p>
        <ul>
          <li>Report creditor visits to your address</li>
          <li>Get immediate assistance if agents are present</li>
          <li>Document visit notifications</li>
        </ul>

        <div className="mb-2">
          <p>Have you had a creditor or agent visit?</p>
          <select
            className="input"
            name="agentVisit"
            value={visitInputs.agentVisit}
            onChange={handleVisitInputs}
          >
            <option value="">Please select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <p className="text-danger">{visitInputsError.agentVisit}</p>
        </div>
        {visitInputs.agentVisit.toLowerCase() === "yes" && (
          <div className="mb-2">
            <p>Is the Agent still at your address?</p>
            <select
              className="input"
              name="still"
              value={visitInputs.still}
              onChange={handleVisitInputs}
            >
              <option value="">Please select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <p className="text-danger">{visitInputsError.still}</p>
          </div>
        )}
        <div className="mb-2">
          <p>Do you need us to call you as soon as possible</p>
          <select
            className="input"
            name="callNow"
            value={visitInputs.callNow}
            onChange={handleVisitInputs}
          >
            <option value="">Please select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <p className="text-danger">{visitInputsError.callNow}</p>
        </div>
        <div className="mb-2">
          <p>Can you provide the collection agent number?</p>
          <input
            type="text"
            className="input"
            name="agentNumber"
            value={visitInputs.agentNumber}
            onChange={handleVisitInputs}
          />
          <p className="text-danger">{visitInputsError.agentNumber}</p>
        </div>
        <div className="mb-2">
          <p>Name of the creditor</p>
          <input
            type="text"
            className="input"
            name="agentName"
            value={visitInputs.agentName}
            onChange={handleVisitInputs}
          />
          <p className="text-danger">{visitInputsError.agentName}</p>
        </div>
        <div className="mb-2">
          <p>Have you recieved a notification of a visit?</p>
          <select
            className="input"
            name="notification"
            value={visitInputs.notification}
            onChange={handleVisitInputs}
          >
            <option value="">Please select</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <p className="text-danger">{visitInputsError.notification}</p>
        </div>
        {visitInputs.notification.toLowerCase() === "yes" && (
          <div>
            <p>Can you copy & paste the message into this field?</p>
            <textarea
              className="input"
              name="message"
              value={visitInputs.message}
              onChange={handleVisitInputs}
            ></textarea>
            <p className="text-danger">{visitInputsError.message}</p>
          </div>
        )}
        <div className="text-end">
          <button className="button" onClick={submitVisitInputs}>
            Submit
          </button>
        </div>
      </div>
      <hr />
      <div className="my-4">
        <p className="fw-bold">Call Forwarding - Technical Issue</p>
        <ul>
          <li>Technical issue with call forwarding</li>
          <li>Need assistance setting up forwarding</li>
        </ul>
        <div>
          <p>Are you facing call forwarding issues?</p>
          <div className="d-flex align-items-center justify-content-start gap-2 mt-2">
            <button
              className="button"
              style={{ width: "75px" }}
              onClick={() => submitIssue("yes")}
            >
              Yes
            </button>
            <button
              className="button"
              style={{ width: "75px" }}
              onClick={() => submitIssue("no")}
            >
              No
            </button>
          </div>
        </div>
      </div>

      <hr />

      <div className="my-4">
        <p className="fw-bold">Other Creditors Issues</p>
        <ul>
          <li>Other issues you are experiencing with creditors</li>
        </ul>

        <div>
          <p>Please enter the issue you are facing</p>
          <div className="mb-2">
            <textarea
              className="input"
              value={otherIssue}
              onChange={handleOtherIssue}
            ></textarea>
            <p className="text-danger">{otherIssueError}</p>
          </div>
          {/* <div className="mb-2">
            <input
              type="file"
              className="input"
              ref={fileInput}
              onChange={handleFile}
              accept=".pdf,image/*,video/mp4,video/webm,video/ogg"
            />
            <p className="primary-text">{fileError}</p>
          </div> */}
          <button className="button" onClick={submitOtherIssue}>
            Submit
          </button>
        </div>
      </div>
    </>
  );
};

export default ParaLegal;
